<template>
  <div
    class="flex-col justify-start relative page"
    :style="`background-image: url('${loginBg}')`"
  >
    <a class="back" href="/">返回首页</a>
    <div class="section"></div>
    <div class="title-box">
      <span class="text_2 pos_2">EECA</span>
      <span class="text pos">电工行业高质量发展合格评定创新平台</span>
    </div>
    <div class="flex-col section_2 pos_3">
      <div class="flex-col">
        <div class="flex-row justify-between self-stretch group">
          <span class="font text_3">账号登录</span>
        </div>
      </div>
      <div class="flex-row items-center group_2">
        <el-input
          class="input"
          placeholder="请输入您的账号"
          v-model="account"
        >
          <i slot="prefix" class="el-input__icon el-icon-user"></i>
        </el-input>
      </div>
      <div class="flex-col group_3">
        <div class="flex-row items-center group_4">
          <el-input
            class="input"
            placeholder="请输入您的密码"
            type="password"
            v-model="password"
          >
            <i slot="prefix" class="el-input__icon el-icon-lock"></i>
          </el-input>
        </div>
        <div class="flex-row justify-between group_5">
          <div class="flex-row">
            <el-checkbox v-model="checked">记住密码</el-checkbox>
            <!--<span class="font_3 text_7 ml-19"></span>-->
          </div>
          <span class="font_3 text_8" @click="goPlatApply">机构申请</span>
          <!--<span class="font_3 text_8" @click="goRegister">账号注册</span>-->
        </div>
      </div>
      <div class="flex-col justify-start items-center text-wrapper" @click="goLogin"><span class="text_9">登录</span></div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    const { loginBg } = this.$images
    return {
      account: '',
      password: '',
      checked: false,
      loginBg
    }
  },
  created () {
    // 拿缓存登录账号
    if (localStorage.getItem('userInfo')) {
      const {
        account,
        password
      } = JSON.parse(localStorage.getItem('userInfo'))
      this.account = account
      this.password = password
      this.checked = true
    }
  },
  methods: {
    goPlatApply () {
      this.$router.push('/server?type=7')
    },
    goRegister () {
      this.$router.push('/register')
    },
    goLogin () {
      // todo 去登录获取token
      if (!this.account) {
        return this.$message.error('账号不能为空')
      }
      if (!this.password) {
        return this.$message.error('密码不能为空')
      }
      this.$https.login({
        username: this.account,
        password: this.password
      }).then(res => {
        if (res.data.status) {
          if (this.checked) {
            localStorage.setItem('userInfo', JSON.stringify({
              account: this.account,
              password: this.password
            }))
          } else {
            localStorage.setItem('userInfo', '')
          }
          console.log('login==>', res)
          this.$message.success('登录成功')
          this.$router.push({ path: '/' })
          window.location.reload()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  .back{
    position: fixed;
    top: 20px;
    left: 20px;
    background-color: #0071d6;
    border-radius: 2px;
    width: 94px;
    height: 32px;
    line-height: 32px;
    cursor: pointer;
    text-align: center;
    color: white;
    text-decoration: none;

    &:hover{
      opacity: .8;
    }
  }
  .el-icon-user,
  .el-icon-lock{font-size: 24px;}
  .input /deep/ .el-input__inner{
    border:none;
    font-size: 16px;
    padding-left: 40px;
  }
  .ml-15 {
    margin-left: 15px;
  }
  .ml-19 {
    margin-left: 19px;
  }
  .flex-row{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .page {
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 100%;
    height: 1080px;
    .section {
      background-size: 100% 100%;
      background-repeat: no-repeat;
      height: 1080px;
      min-width: calc(100vw);
    }
    .text_2 {
      color: #ffffff;
      font-size: 50px;
      line-height: 40px;
      font-weight: bold;
      margin-right: 10px;
    }
    .title-box{
      position: absolute;
      top: 141px;
      width: 100%;
      text-align: center;
    }
    .pos_2 {
      /*position: absolute;*/
      left: 510px;
      top: 141px;
    }
    .text {
      color: #ffffff;
      font-size: 45px;
      line-height: 50px;
      text-transform: uppercase;
    }
    .pos {
      /*position: absolute;*/
      right: 505px;
      top: 137px;
    }
    .section_2 {
      padding: 40px 45px;
      background-color: #ffffff;
      border-radius: 5px;
      width: 500px;
      .group {
        padding: 0 30px 18px 33px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        .font {
          font-size: 24px;
          font-family: Alibaba;
          line-height: 23px;
        }
        .text_3 {
          color: #1d66d6;
        }
        .text_4 {
          color: #999999;
        }
      }
      .section_3 {
        background-color: #3f95ff;
        width: 160px;
        height: 2px;
      }
      .group_2 {
        margin: 50px 26px 0;
        padding: 0 11px 10px;
        border-bottom: solid 1px #dfdfdf;
        .image {
          width: 24px;
          height: 24px;
        }
        .text_5 {
          margin-right: 184px;
        }
      }
      .group_3 {
        padding: 43px 26px 31px;
        .group_4 {
          padding: 7px 12px;
          border-bottom: solid 1px #dfdfdf;
          .image_2 {
            width: 22px;
            height: 24px;
          }
          .text_6 {
            margin-right: 184px;
          }
        }
        .group_5 {
          padding: 24px 16px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;

          /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
            color: #1d66d6 !important;
          }
          /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner{
            background-color: #1d66d6 !important;
            border-color: #1d66d6 !important;
          }

          .group_6 {
            border-radius: 1px;
            width: 14px;
            height: 14px;
            border-left: solid 1px #b1b1b1;
            border-right: solid 1px #b1b1b1;
            border-top: solid 1px #b1b1b1;
            border-bottom: solid 1px #b1b1b1;
          }
          .font_3 {
            font-size: 14px;
            font-family: Alibaba;
            line-height: 14px;
          }
          .text_7 {
            color: #999999;
            cursor: pointer;
          }
          .text_8 {
            margin-right: 3px;
            color: #1d66d6;
            cursor: pointer;
          }
        }
      }
      .font_2 {
        font-size: 16px;
        font-family: Alibaba;
        line-height: 16px;
        color: #999999;
      }
      .text-wrapper {
        margin: 0 24px;
        padding: 16px 0;
        background-color: #006ed1;
        box-shadow: 0px 4px 10px #3f95ff80;
        border-radius: 24px;
        width: 360px;
        text-align: center;
        cursor: pointer;
        .text_9 {
          color: #ffffff;
          font-size: 18px;
          font-family: Alibaba;
          line-height: 17px;
        }
      }
    }
    .pos_3 {
      position: absolute;
      left: 50%;
      top: 360px;
      transform: translateX(-50%);
    }
  }
</style>
